<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import List from './list'
import Form from './form'
import FormChangePassword from './form-change-password'

/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    List,
    Form,
    FormChangePassword,
  },
  data() {
    return {
      title: "User",
      items: [
        {
          text: "VMCore"
        },
        {
          text: "User",
          active: true
        }
      ]
    };
  },
  methods :{
    onActiveChange(b) {
      this.$refs.list.setActive(!b);
    },
    onRefresh(){
      this.$refs.list.fetchData()
    },
    onEdit(id){
      this.$refs.form.initUpdate(id)
    },
    onEditPassword(id){
      this.$refs.form_edit_password.initUpdate(id)
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <Form ref="form" @refresh="onRefresh" @active_change="onActiveChange"/>
        <FormChangePassword ref="form_edit_password" @refresh="onRefresh" @active_change="onActiveChange"/>
        <List ref="list" @onEdit="onEdit" @onEditPassword="onEditPassword" />
      </div>
      
    </div>
  </Layout>
</template>